import { Directive, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingFacade } from '~/app/domains/onboarding/onboarding.facade';

@Directive({
    selector: '[ebSupademoAutoLaunch]',
    standalone: true
})
export class SupademoAutoLaunchDirective implements OnInit {
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);
    private onboardingFacade = inject(OnboardingFacade);

    async ngOnInit(): Promise<void> {
        const tutorialParams = this.getTutorialParams();

        if (tutorialParams.demoId) {
            await this.openDemo(tutorialParams.demoId, tutorialParams.supademoOptions);
            await this.clearQueryParams();
        }
    }

    private getTutorialParams() {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        return {
            demoId: queryParams['tutorial'],
            supademoOptions: queryParams['supademoOptions'],
        };
    }

    private async openDemo(demoId: string, options: any): Promise<void> {
        await this.onboardingFacade.openSupaDemoVideoByDemoId(demoId, options);
    }

    private async clearQueryParams(): Promise<void> {
        await this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {},
            replaceUrl: true
        });
    }
}
